if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;

        this.realSubmit = this.form.querySelector('[type="submit"]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.variantLabel = this.querySelector('[data-sticky-variant]');
        this.image = this.querySelector('.sticky-atc__image');
        this.productInfo = this.form.closest('product-info') || this.form.closest('section');

        // Phones: show the bar whenever the real Add to cart button is off
        // screen, including at page load while it is still below the fold.
        // Wider screens: only after the shopper has scrolled past it.
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.mainInView = true;
        this.mainAbove = false;

        this.removeAttribute('hidden');
        this.button.addEventListener('click', this.onClick.bind(this));

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.mainInView = entry.isIntersecting;
            this.mainAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.updateVisibility();
          },
          { threshold: 0 }
        );
        this.observeTarget();

        this.onMediaChange = this.updateVisibility.bind(this);
        if (this.mobileQuery.addEventListener) this.mobileQuery.addEventListener('change', this.onMediaChange);

        // Mirror price, variant + availability whenever Dawn re-renders the
        // buy box (variant changes swap DOM inside product-info).
        this.mirror = this.mirrorFromForm.bind(this);
        this.mutationObserver = new MutationObserver(this.mirror);
        if (this.productInfo) {
          this.mutationObserver.observe(this.productInfo, { childList: true, subtree: true });
        }
        this.mirrorFromForm();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.mobileQuery && this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.onMediaChange);
        }
      }

      // Watch the real submit button (fall back to the form). Re-attach if a
      // re-render replaced it.
      observeTarget() {
        const target = this.realSubmit && this.realSubmit.isConnected ? this.realSubmit : this.form;
        if (target === this.observedTarget) return;
        if (this.observedTarget) this.observer.unobserve(this.observedTarget);
        this.observedTarget = target;
        this.observer.observe(target);
      }

      updateVisibility() {
        const show = !this.mainInView && (this.mainAbove || this.mobileQuery.matches);
        this.toggleAttribute('data-visible', show);
      }

      mirrorFromForm() {
        if (!this.productInfo) return;
        if (!this.realSubmit || !this.realSubmit.isConnected) {
          this.realSubmit = this.form.querySelector('[type="submit"]');
          if (this.observer) this.observeTarget();
        }
        const priceEl = this.productInfo.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');
        if (priceEl && this.price) {
          const text = priceEl.textContent.trim();
          if (this.price.textContent !== text) this.price.textContent = text;
        }
        const variant = this.readSelectedVariant();
        if (variant && this.variantLabel) {
          const title = variant.title && variant.title !== 'Default Title' ? variant.title : '';
          if (this.variantLabel.textContent !== title) this.variantLabel.textContent = title;
          this.variantLabel.hidden = title === '';
        }
        if (variant && this.image && variant.featured_media && variant.featured_media.preview_image) {
          const src = variant.featured_media.preview_image.src;
          if (src) {
            const sized = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
            if (this.image.getAttribute('src') !== sized) this.image.setAttribute('src', sized);
          }
        }
        if (this.realSubmit && this.label) {
          const realLabel = this.realSubmit.querySelector('span');
          if (realLabel) {
            const text = realLabel.textContent.trim();
            if (this.label.textContent !== text) this.label.textContent = text;
          }
          this.button.toggleAttribute('disabled', this.realSubmit.hasAttribute('disabled'));
        }
      }

      readSelectedVariant() {
        const script = this.productInfo.querySelector('variant-selects [data-selected-variant]');
        if (!script) return null;
        try {
          return JSON.parse(script.textContent);
        } catch (e) {
          return null;
        }
      }

      onClick() {
        if (!this.realSubmit || this.realSubmit.hasAttribute('disabled')) return;
        this.realSubmit.click();
      }
    }
  );
}
